module.exports = __webpack_public_path__ + "13de5ef93de4cc429c01f71b174c50cd.svg";